import * as React from 'react';
import { ESizes } from '../types';
import { Block } from './Block';
import { useMediaQuery } from './useMediaQuery';

const PixelRem = 1 / 16;

interface ITextOptions {
    fontSize: number;
    lineHeight: number;
}

type IBreakPoints = Partial<Record<ESizes, ITextOptions>>;

interface IResponsiveTextBaseProps {
    component?: string;
    base: ITextOptions;
    [key: string | number]: any;
}

export type IResponsiveTextProps = IResponsiveTextBaseProps & IBreakPoints;

export const ResponsiveText: React.FC<IResponsiveTextProps> = ({
    base,
    component = 'div',
    ...props
}) => {
    const activeSize = useMediaQuery();
    const { fontSize, lineHeight } = props[activeSize] || base;

    return (
        <Block
            style={{
                fontSize: `${fontSize * PixelRem}rem`,
                lineHeight: `${lineHeight * PixelRem}rem`,
            }}
            component={component}
            {...props}
        />
    );
};
